import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FaqItem, HELP_FAQS } from '../help-faqs.data';

@Component({
  selector: 'app-help-hero',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './help-hero.html',
  styleUrl: './help-hero.css',
})
export class HelpHeroComponent {
  @Output() searchChange = new EventEmitter<string>();

  searchTerm = '';
  showSuggestions = false;

  get suggestions(): FaqItem[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      return [];
    }
    return HELP_FAQS.filter(
      (faq) => faq.question.toLowerCase().includes(term) || faq.answer.toLowerCase().includes(term)
    ).slice(0, 5);
  }

  onSearchInput(): void {
    this.searchChange.emit(this.searchTerm);
    this.showSuggestions = this.searchTerm.trim().length > 0;
  }

  onSearchFocus(): void {
    this.showSuggestions = this.searchTerm.trim().length > 0;
  }

  onSearchBlur(): void {
    // Let a click on a suggestion register before the list disappears.
    setTimeout(() => (this.showSuggestions = false), 150);
  }

  selectSuggestion(faq: FaqItem): void {
    this.searchTerm = faq.question;
    this.onSearchInput();
    this.goToFaq();
  }

  submitSearch(): void {
    this.onSearchInput();
    this.goToFaq();
  }

  private goToFaq(): void {
    document.getElementById('help-faq-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  scrollToContact(): void {
    document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
